import api from "@/api/axios";

const pujaModel = {
    data: {
            id: null,
            lote_id: null,
            subasta_id: null,
            oferta_anterior: null,
            incremento: null,
            oferta_actual: null,
            user_ultima_oferta_id: null,
            fecha_hora_inicio: null,
            fecha_hora_cierre: null,
            created_at: null,
            updated_at: null,
            deleted_at: null,
            ofertas: [], 
    },
    async obtenerPuja(params) {
        try {
            const response = await api.get("/pujas", {
                params: params, 
            })
            
            const puja = response.data;
            return puja;
        } catch (error) {
            console.error("Error al obtener la puja:", error);
            throw error;
        }
    },

    async ofertar(params) {
        try {
            await api.post("/pujas/ofertas", 
            params,
            )
        } catch (error) {
            console.error("Error al ofertar:", error);
            throw error;
        }
    },

};

export default pujaModel;